import React, {FC, Fragment} from 'react';

import {Text} from '@optimaxdev/design-system';

import AnimateHeight from 'react-animate-height';

import {Price} from 'components/price/price';
import {BaseItemPrice} from 'desktop/components/baseItemPrice/baseItemPrice';
import {useDescription, useUsage} from 'desktop/components/cartItemHelper/cartItemHelper';
import {UPGRADE_ALIASES} from 'desktop/pages/cart/constants/upsells';

import {OrderDetailsItemOptionType, OrderDetailsItemsType} from 'types/orderDetailsTypes';

import {getCommonTextProps} from './helpers';

import {NotificationBox} from './notificationBox/notificationBox';

import s from './glassesItemDetails.scss';

export type PropsType = {
    item: OrderDetailsItemsType;
    isOpened: boolean;
};

/**
 * Component details for product item glasses TYP
 */
export const GlassesItemDetails: FC<PropsType> = ({isOpened, item}) => {
    const usage: OrderDetailsItemOptionType = useUsage(item);
    const description = useDescription(item, item.product.type);

    const allOptions: OrderDetailsItemOptionType[] = Object.values(item.options);

    const upgrades = allOptions.filter(
        addedOption => addedOption.option && UPGRADE_ALIASES.includes(addedOption.option.alias),
    );

    const {product} = item;

    return (
        <AnimateHeight height={isOpened ? 'auto' : 0}>
            <div className={s.content}>
                <div>
                    <Text {...getCommonTextProps()} bold>
                        Frame{' '}
                    </Text>
                    <Text {...getCommonTextProps()} margin="0" light>
                        {`${item.windowName}, ${product.color}, ${product.size}`} (
                        <Price>{product.finalPrice}</Price>)
                    </Text>
                </div>

                {usage && (
                    <div>
                        <Text {...getCommonTextProps()} bold>
                            Lens{' '}
                        </Text>
                        <Text {...getCommonTextProps()} margin="0" light>
                            {usage.title}
                        </Text>
                    </div>
                )}
                <div>
                    <Text {...getCommonTextProps()} margin="0" bold>
                        Prescription filled
                    </Text>
                    <NotificationBox isPrescriptionNeeded={item.isPrescriptionNeeded} />
                    <Text {...getCommonTextProps()} className={s.description} margin="0" light>
                        {description}
                    </Text>
                </div>
                {Boolean(upgrades?.length) && (
                    <div>
                        <Text {...getCommonTextProps()} bold>
                            Upgrades
                        </Text>
                        <Text {...getCommonTextProps()} margin="0" light>
                            {upgrades
                                .sort((a, b) => a.option.sort - b.option.sort)
                                .map((value, index) => (
                                    <Fragment key={value.id}>
                                        {value.price === value.finalPrice &&
                                            value.finalPrice > 0 && (
                                                <>
                                                    {value.title}&nbsp;(
                                                    <Price>{value.finalPrice}</Price>)
                                                    {index === upgrades.length - 1 ? '' : ', '}
                                                </>
                                            )}
                                        {value.finalPrice > 0 && value.price > value.finalPrice && (
                                            <>
                                                {value.title}
                                                <>&nbsp;</>
                                                <span className={s.upgradePrice}>
                                                    (
                                                    <BaseItemPrice
                                                        price={value.price}
                                                        specialPrice={value.finalPrice}
                                                    />
                                                    )
                                                    <>
                                                        {index !== upgrades.length - 1 && ', '}
                                                        &nbsp;
                                                    </>
                                                </span>
                                            </>
                                        )}
                                    </Fragment>
                                ))}
                        </Text>
                    </div>
                )}
            </div>
        </AnimateHeight>
    );
};
